var React = require('react');

function GrayArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#9696A4","strokeLinecap":"round","strokeWidth":"1.867","opacity":".6"},[React.createElement("path",{"strokeLinejoin":"round","d":"M7.069 1L1 7.528l6.069 6.986","key":0}),React.createElement("path",{"d":"M1 7.757h13.444","key":1})]));
}

GrayArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = GrayArrow;

GrayArrow.default = GrayArrow;
